import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import MaintenanceModel from './maintenance-model';
import MaintenanceModelDetail from './maintenance-model-detail';
import MaintenanceModelUpdate from './maintenance-model-update';
import MaintenanceModelDeleteDialog from './maintenance-model-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={MaintenanceModelUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={MaintenanceModelUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={MaintenanceModelDetail} />
      <ErrorBoundaryRoute path={match.url} component={MaintenanceModel} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={MaintenanceModelDeleteDialog} />
  </>
);

export default Routes;
